import { Button } from '@chakra-ui/react';
import { HandleToggleProps } from '@components/Header/interface';
import { GiHamburgerMenu } from 'react-icons/gi';

export function ButtonMenu({ handleToggle }: HandleToggleProps) {
	return (
		<Button onClick={handleToggle}>
			<GiHamburgerMenu size={24} />
		</Button>
	);
}
